import type { ReactElement } from 'react';
import type { SyncStatus } from '../../hooks/useOfflineSync.js';

export interface StatusPillProps {
  status: SyncStatus;
  pending: number;
}

export function StatusPill({ status, pending }: StatusPillProps): ReactElement {
  let text: string;
  let bg: string;
  let fg: string;
  if (status === 'offline') {
    text = `Offline - Saved${pending > 0 ? ` (${pending})` : ''}`;
    bg = 'color-mix(in srgb, #f59e0b 18%, transparent)';
    fg = '#92400e';
  } else if (status === 'syncing') {
    text = pending > 0 ? `Syncing... (${pending})` : 'Syncing...';
    bg = 'color-mix(in srgb, #2563eb 18%, transparent)';
    fg = '#1e3a8a';
  } else {
    text = pending > 0 ? `Synced (${pending})` : 'Synced';
    bg = 'color-mix(in srgb, #059669 18%, transparent)';
    fg = '#065f46';
  }
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
      style={{ background: bg, color: fg }}
      data-testid="shopping-status"
      data-status={status}
    >
      {text}
    </span>
  );
}
